import { BasicValueUnitGetModuleFactory } from '../../endpoints/basic/valueUnit/get.module.js';
import '../../endpoints/index/constituents/list.module.js';
import { InstrumentGetByNotationModuleFactory } from '../../endpoints/instrument/getByNotation.module.js';
import '../../endpoints/instrument/crossreference.module.js';
import '../../endpoints/instrument/coupon/keyData/get.module.js';
import '../../endpoints/instrument/exchangeRate/getByISOCode.module.js';
import '../../endpoints/notation/crossReference/listByInstrument.module.js';
import '../../endpoints/notation/keyFigures/get.module.js';
import { NotationGetModuleFactory } from '../../endpoints/notation/get.module.js';
import { PricesListModuleFactory } from '../../endpoints/prices/list.module.js';
import '../../endpoints/debtInstrument/get.module.js';
import '../../endpoints/legalEntity/company/get.module.js';
import '../../endpoints/legalEntity/address/list.module.js';
import '../../endpoints/news/article/get.module.js';
import '../../endpoints/news/article/searchByText.module.js';
import '../../endpoints/fund/shareClass/get.module.js';
import '../../endpoints/instrument/benchmark/list.module.js';
import '../../endpoints/prices/bidAsk/list.module.js';
import '../../endpoints/securitizedDerivative/get.module.js';
import '../../endpoints/company/keyItems/fiscalYear/listByInstrument.module.js';
import '../../endpoints/instrument/category/list.module.js';
import '../../endpoints/securitizedDerivative/keyFigures/notation/get.module.js';
import '../../endpoints/notation/searchByText.module.js';
import '../../endpoints/prices/timeSeries/eod/list.module.js';
import '../../endpoints/prices/timeSeries/intraday/subsample/list.module.js';
import '../../endpoints/company/board/listByInstrument.module.js';
import '../../endpoints/prices/orderbook/aggregated/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/get.module.js';
import '../../endpoints/company/estimates/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/benchmark/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/type/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/performance/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/fee/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/manager/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/riskFigures/listByInstrument.module.js';
import '../../endpoints/stock/owner/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/evaluation/getByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/holding/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/eod/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/intraday/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/type/list.module.js';
import '../../endpoints/securitizedDerivative/notation/screener/search.module.js';
import '../../endpoints/basic/market/list.module.js';
import '../../endpoints/basic/language/list.module.js';
import '../../endpoints/basic/valueUnit/currency/main/list.module.js';
import '../../endpoints/basic/frequency/type/list.module.js';
import '../../endpoints/legalEntity/list.module.js';
import '../../endpoints/instrument/coupon/interestRate/type/list.module.js';
import '../../endpoints/instrument/backgroundText/listByInstrument.module.js';
import '../../endpoints/stock/recommendation/aggregate/history/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/investmentFocus/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/exchange/list.module.js';
import '../../endpoints/stock/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/status/get.module.js';
import '../../endpoints/instrument/complianceProperty/listByInstrument.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/list.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/get.module.js';
import '../../endpoints/calendarEvent/list.module.js';
import '../../endpoints/calendarEvent/get.module.js';
import '../../endpoints/stock/notation/screener/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/figure/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/ranking/listByInstrument.module.js';
import '../../endpoints/news/article/listByMediaKind.module.js';
import '../../endpoints/documents/searchByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/narrative/get.module.js';
import '../../endpoints/debtInstrument/keyFigures/notation/get.module.js';
import '../../endpoints/securitizedDerivative/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/keyFigures/list.module.js';
import '../../endpoints/instrument/legalEntity/backgroundText/listByInstrument.module.js';
import '../../endpoints/securitizedDerivative/underlying/list.module.js';
import '../../endpoints/basic/market/get.module.js';
import '../../endpoints/securitizedDerivative/issuer/search.module.js';
import '../../endpoints/prices/tradingSchedule/event/list.module.js';
import '../../endpoints/debtInstrument/issuer/search.module.js';
import '../../endpoints/debtInstrument/notation/screener/search.module.js';
import '../../endpoints/watchlist/create.module.js';
import '../../endpoints/watchlist/delete.module.js';
import '../../endpoints/watchlist/list.module.js';
import '../../endpoints/watchlist/get.module.js';
import '../../endpoints/watchlist/modify.module.js';
import '../../endpoints/watchlist/position/create.module.js';
import '../../endpoints/watchlist/position/delete.module.js';
import '../../endpoints/watchlist/position/list.module.js';
import '../../endpoints/watchlist/position/get.module.js';
import '../../endpoints/watchlist/position/modify.module.js';
import '../../endpoints/basic/region/list.module.js';
import '../../endpoints/portfolio/transaction/list.module.js';
import '../../endpoints/portfolio/list.module.js';
import '../../endpoints/portfolio/position/list.module.js';
import '../../endpoints/portfolio/get.module.js';
import '../../endpoints/portfolio/create.module.js';
import '../../endpoints/portfolio/modify.module.js';
import '../../endpoints/portfolio/delete.module.js';
import '../../endpoints/portfolio/transaction/create.module.js';
import '../../endpoints/portfolio/transaction/delete.module.js';
import '../../endpoints/portfolio/transaction/modify.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/screener/search.module.js';
import '../../endpoints/basic/region/country/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/element/list.module.js';
import '../../endpoints/instrument/get.module.js';
import '../../endpoints/portfolio/evaluation/list.module.js';
import '../../endpoints/stock/recommendation/aggregate/get.module.js';
import '../../endpoints/prices/timeSeries/eod/subsample/get.module.js';
import '../../endpoints/category/listBySystem.module.js';
import '../../endpoints/alerting/prices/basic/alert/get.module.js';
import '../../endpoints/alerting/prices/basic/alert/list.module.js';
import '../../endpoints/alerting/prices/basic/alert/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/create.module.js';
import '../../endpoints/alerting/prices/basic/trigger/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/get.module.js';
import { AlertingPricesBasicTriggerListModuleFactory } from '../../endpoints/alerting/prices/basic/trigger/list.module.js';
import '../../endpoints/alerting/prices/basic/trigger/modify.module.js';
import '../../endpoints/company/logo/get.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/assetClass/list.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/sector/list.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/managers/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/benchmarkDetails/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/summary/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/classifications/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/costsFees/get.module.js';
import '../../endpoints/factset/content/factsetOwnership/v1/fundHoldings/get.module.js';
import '../../endpoints/fund/holding/listByInstrument.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/returnsSnapshot/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScores/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScoresAll/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/annualizedTotalReturn/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/cumulativeTotalReturn/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/esg/getByInstrument.module.js';
import '../../endpoints/fund/breakdown/position/ListByInstrument.module.js';
import '../../endpoints/product/widgets/portfolio/holdings/list.module.js';
import '../../endpoints/product/widgets/portfolio/weights/list.module.js';
import '../../endpoints/product/widgets/portfolio/characteristics/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/attribution/list.module.js';
import '../../endpoints/notation/crossReference/listBySymbol.module.js';
import '../../endpoints/notation/crossReference/listByISIN.module.js';
import '../../endpoints/instrument/notation/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/countries/get.module.js';
import '../../endpoints/news/article/type/list.module.js';
import '../../endpoints/news/publisher/list.module.js';
import '../../endpoints/category/system/list.module.js';
import '../../endpoints/news/distributor/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/regions/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/discreteTotalReturn/list.module.js';
import '../../endpoints/index/get.module.js';
import '../../endpoints/fund/notation/screener/search.module.js';
import '../../endpoints/basic/valueUnit/list.module.js';
import '../../endpoints/fund/issuer/search.module.js';
import '../../endpoints/rating/grade/listBySystem.module.js';
import '../../endpoints/fund/notation/screener/valueRanges/get.module.js';
import '../../subscriptions/news/article/searchByText.module.js';
import '../../subscriptions/news/article/listByMediaKind.module.js';
import { PricesGetSubscriptionModuleFactory } from '../../subscriptions/prices/get.module.js';
import '../../subscriptions/prices/bidAsk/get.module.js';
import '../../subscriptions/vendor/tradingCentral/technicalAnalysis/list.module.js';
import '../../subscriptions/alerting/prices/basic/alert/list.module.js';
import '../../subscriptions/prices/orderbook/aggregated/get.module.js';
import { getEndpointOptions, getLanguage, convertMdg2DateTimeResponse, mapAssetClass } from '../../helpers/common.js';
import 'lodash.set';
import { Mdg2StoreModuleFactory } from '../../abstracts/Mdg2StoreModuleFactory.js';
import '../../abstracts/Mdg2EndpointStoreModuleFactory.js';
import '../../abstracts/Mdg2SubscriptionStoreModuleFactory.js';
import 'vue';
import 'lodash.matches';

var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q;
class AlertTriggersListStoreModuleFactory extends Mdg2StoreModuleFactory {
  constructor() {
    super(...arguments);
    this.defaultLanguage = "en";
    this.defaultNameType = "name";
    this.defaultFallbackForNameType = true;
    this.quality = (_c = (_b = (_a = this.options) == null ? void 0 : _a.prices) == null ? void 0 : _b.quality) != null ? _c : "BST";
    this.sameQuality = (_f = (_e = (_d = this.options) == null ? void 0 : _d.prices) == null ? void 0 : _e.sameQuality) != null ? _f : false;
    this.isPushEnabled = (_i = (_h = (_g = this.options) == null ? void 0 : _g.push) == null ? void 0 : _h.enabled) != null ? _i : true;
    this.nameType = (_m = (_l = (_k = (_j = this.options) == null ? void 0 : _j.instrument) == null ? void 0 : _k.name) == null ? void 0 : _l.type) != null ? _m : this.defaultNameType;
    this.isNameTypeFallbackEnabled = (_q = (_p = (_o = (_n = this.options) == null ? void 0 : _n.instrument) == null ? void 0 : _o.name) == null ? void 0 : _p.fallback) != null ? _q : this.defaultFallbackForNameType;
  }
  getResponse(payload) {
    return {
      data: this.getResponseData(payload),
      meta: this.getResponseMeta(payload)
    };
  }
  async updateComponentsInputs(payload) {
    let isResponseSuccessful = true;
    try {
      await this.updateAlertingPricesBasicTriggerList(payload);
      const triggerListResults = this.getAlertingPricesBasicTriggerListData(payload);
      const ids = (triggerListResults != null ? triggerListResults : []).map((item) => item.notation.id);
      await Promise.all([
        this.updatePricesList(ids),
        ...ids.map(async (idNotation) => this.updateInstrumentGetByNotation(idNotation, payload)),
        ...ids.map(async (idNotation) => this.updateNotationGet(idNotation, payload))
      ]);
      if (this.isPushEnabled) {
        await Promise.all(
          ids.map(async (idNotation) => {
            return this.updatePricesGetSubscription(idNotation);
          })
        );
      }
      await Promise.all(
        ids.map(async (idNotation) => {
          return this.updateBasicValueUnit(idNotation);
        })
      );
    } catch (error) {
      this.logger.error(error);
      isResponseSuccessful = false;
    }
    return Promise.resolve(isResponseSuccessful);
  }
  async cleanUp(payload) {
    var _a2;
    if (this.isPushEnabled) {
      const triggerListData = this.getAlertingPricesBasicTriggerListData(payload);
      await Promise.all(
        (_a2 = triggerListData == null ? void 0 : triggerListData.map(async (trigger) => {
          return this.removeInactivePricesGetSubscription(trigger.notation.id);
        })) != null ? _a2 : []
      );
    }
    return Promise.resolve(true);
  }
  getEndpoints() {
    var _a2, _b2, _c2, _d2;
    if (!this.endpoints) {
      const endpointConfiguration = (_a2 = this.options) == null ? void 0 : _a2.endpointConfiguration;
      const pricesGetSubscriptionOptions = {
        granularity: (_d2 = (_c2 = (_b2 = this.options) == null ? void 0 : _b2.push) == null ? void 0 : _c2.granularity) != null ? _d2 : "1S",
        quality: this.quality,
        ...getEndpointOptions(endpointConfiguration, "pricesGetSubscription")
      };
      this.endpoints = {
        alertingPricesBasicTriggerList: this.getModuleEntity(
          AlertingPricesBasicTriggerListModuleFactory,
          getEndpointOptions(endpointConfiguration, "alertingPricesBasicTriggerList")
        ),
        instrumentGetByNotation: this.getModuleEntity(InstrumentGetByNotationModuleFactory, getEndpointOptions(endpointConfiguration, "instrumentGetByNotation")),
        notationGet: this.getModuleEntity(NotationGetModuleFactory, getEndpointOptions(endpointConfiguration, "notationGet")),
        pricesList: this.getModuleEntity(PricesListModuleFactory, getEndpointOptions(endpointConfiguration, "pricesList")),
        basicValueUnitGet: this.getModuleEntity(BasicValueUnitGetModuleFactory, getEndpointOptions(endpointConfiguration, "basicValueUnitGet")),
        pricesGetSubscription: this.getModuleEntity(PricesGetSubscriptionModuleFactory, pricesGetSubscriptionOptions)
      };
    }
    return this.endpoints;
  }
  getResponseData(payload) {
    const triggerListData = this.getAlertingPricesBasicTriggerListData(payload);
    return (triggerListData != null ? triggerListData : []).map((trigger) => this.getResponseItem(trigger, payload));
  }
  getResponseMeta(payload) {
    var _a2, _b2;
    const triggerListMeta = this.getAlertingPricesBasicTriggerListMeta(payload);
    return {
      sortKeys: {},
      pagination: {
        next: (_a2 = triggerListMeta == null ? void 0 : triggerListMeta.pagination.next) != null ? _a2 : null,
        previous: (_b2 = triggerListMeta == null ? void 0 : triggerListMeta.pagination.previous) != null ? _b2 : null
      }
    };
  }
  getTriggerListRequest(itemsPerPage, cursor) {
    const request = {
      data: {
        filter: {
          status: {
            code: "active"
          }
        }
      },
      meta: {
        pagination: {
          limit: itemsPerPage,
          cursor: cursor != null ? cursor : void 0
        }
      }
    };
    return request;
  }
  getAlertingPricesBasicTriggerList(payload) {
    try {
      const request = this.getTriggerListRequest(payload.itemsPerPage, payload.activePageCursor);
      const response = this.getEndpoints().alertingPricesBasicTriggerList.getData(request);
      return response != null ? response : null;
    } catch (e) {
      return null;
    }
  }
  getAlertingPricesBasicTriggerListData(payload) {
    var _a2;
    const alertingPricesBasicTriggerList = this.getAlertingPricesBasicTriggerList(payload);
    return (_a2 = alertingPricesBasicTriggerList == null ? void 0 : alertingPricesBasicTriggerList.data) != null ? _a2 : null;
  }
  getAlertingPricesBasicTriggerListMeta(payload) {
    var _a2;
    const alertingPricesBasicTriggerList = this.getAlertingPricesBasicTriggerList(payload);
    return (_a2 = alertingPricesBasicTriggerList == null ? void 0 : alertingPricesBasicTriggerList.meta) != null ? _a2 : null;
  }
  async updateAlertingPricesBasicTriggerList(payload) {
    try {
      const request = this.getTriggerListRequest(payload.itemsPerPage, payload.activePageCursor);
      return this.getEndpoints().alertingPricesBasicTriggerList.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getInstrumentGetByNotationRequest(id, payloadLanguage) {
    const language = getLanguage(payloadLanguage, this.defaultLanguage, this.options);
    return { id, _language: language };
  }
  getInstrumentGetByNotationData(id, payload) {
    var _a2;
    try {
      const request = this.getInstrumentGetByNotationRequest(id, payload.language);
      const response = this.getEndpoints().instrumentGetByNotation.getData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (e) {
      return null;
    }
  }
  async updateInstrumentGetByNotation(id, payload) {
    try {
      const request = this.getInstrumentGetByNotationRequest(id, payload.language);
      return this.getEndpoints().instrumentGetByNotation.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getNotationGetDataRequest(id, payloadLanguage) {
    return {
      identifier: id,
      identifierType: "idNotation",
      _language: getLanguage(payloadLanguage, this.defaultLanguage, this.options)
    };
  }
  getNotationGetData(id, payload) {
    try {
      const request = this.getNotationGetDataRequest(id, payload.language);
      const response = this.getEndpoints().notationGet.getData(request);
      return response != null ? response : null;
    } catch (e) {
      return null;
    }
  }
  async updateNotationGet(id, payload) {
    try {
      const request = this.getNotationGetDataRequest(id, payload.language);
      return this.getEndpoints().notationGet.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getPricesListNotationDataRequest(id) {
    return { id, quality: this.quality, sameQuality: this.sameQuality };
  }
  getPricesListRequest(identifiers) {
    return { identifiers, identifierType: "idNotation", quality: this.quality, sameQuality: this.sameQuality };
  }
  getPricesListData(id) {
    var _a2;
    try {
      const request = this.getPricesListNotationDataRequest(id);
      const response = this.getEndpoints().pricesList.getNotationData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (e) {
      return null;
    }
  }
  dedpulicate(ids) {
    return [...new Set(ids)];
  }
  async updatePricesList(ids) {
    try {
      const request = this.getPricesListRequest(this.dedpulicate(ids));
      return this.getEndpoints().pricesList.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getBasicValueUnitRequest(id) {
    return { id };
  }
  getBasicValueUnitData(id) {
    var _a2, _b2;
    try {
      const valueUnitId = (_a2 = this.getPricesListData(id)) == null ? void 0 : _a2.valueUnit.id;
      if (!valueUnitId) {
        return null;
      }
      const request = this.getBasicValueUnitRequest(valueUnitId);
      const response = this.getEndpoints().basicValueUnitGet.getData(request);
      return (_b2 = response == null ? void 0 : response.data) != null ? _b2 : null;
    } catch (e) {
      return null;
    }
  }
  async updateBasicValueUnit(id) {
    var _a2;
    try {
      await this.updatePricesList([id]);
      const valueUnitId = (_a2 = this.getPricesListData(id)) == null ? void 0 : _a2.valueUnit.id;
      if (!valueUnitId) {
        throw new Error("could not get value unit id");
      }
      const request = this.getBasicValueUnitRequest(valueUnitId);
      return this.getEndpoints().basicValueUnitGet.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getPricesGetSubscriptionRequest(identifier) {
    return { identifier, identifierType: "idNotation", quality: this.quality };
  }
  getPricesGetSubscription(id) {
    try {
      const request = this.getPricesGetSubscriptionRequest(id);
      const response = this.getEndpoints().pricesGetSubscription.getData(request);
      return response != null ? response : null;
    } catch (e) {
      return null;
    }
  }
  async updatePricesGetSubscription(id) {
    try {
      const request = this.getPricesGetSubscriptionRequest(id);
      return this.getEndpoints().pricesGetSubscription.fetchObservable(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  async removeInactivePricesGetSubscription(id) {
    try {
      const request = this.getPricesGetSubscriptionRequest(id);
      return this.getEndpoints().pricesGetSubscription.removeSubscriptionIfInactive(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getResponseItem(trigger, payload) {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2, _m2;
    const { id } = trigger.notation;
    const instrumentData = this.getInstrumentGetByNotationData(id, payload);
    const notationData = this.getNotationGetData(id, payload);
    const priceData = this.getPricesListData(id);
    const valueUnit = this.getBasicValueUnitData(id);
    const pricesSubscriptionData = this.isPushEnabled ? this.getPricesGetSubscription(id) : null;
    const nameFallback = this.isNameTypeFallbackEnabled ? instrumentData == null ? void 0 : instrumentData.name : null;
    return {
      id: trigger.id,
      dateTime: convertMdg2DateTimeResponse((_a2 = trigger.creation) != null ? _a2 : null),
      limit: {
        above: (_b2 = trigger.range.upperLimit) != null ? _b2 : null,
        below: (_c2 = trigger.range.lowerLimit) != null ? _c2 : null
      },
      security: {
        id,
        name: instrumentData ? (_e2 = (_d2 = instrumentData[this.nameType]) != null ? _d2 : nameFallback) != null ? _e2 : null : null,
        isin: (_f2 = instrumentData == null ? void 0 : instrumentData.isin) != null ? _f2 : null,
        lastPrice: (_h2 = (_g2 = pricesSubscriptionData == null ? void 0 : pricesSubscriptionData.data.latest.price) != null ? _g2 : priceData == null ? void 0 : priceData.latest.price) != null ? _h2 : null,
        lastPriceDateTime: convertMdg2DateTimeResponse((_j2 = (_i2 = pricesSubscriptionData == null ? void 0 : pricesSubscriptionData.data.latest.time) != null ? _i2 : priceData == null ? void 0 : priceData.latest.time) != null ? _j2 : null),
        lastPriceQuality: (_k2 = priceData == null ? void 0 : priceData.quality) != null ? _k2 : null,
        currency: (_l2 = valueUnit == null ? void 0 : valueUnit.code) != null ? _l2 : null,
        assetClass: mapAssetClass(instrumentData == null ? void 0 : instrumentData.assetClass.code),
        exchange: (_m2 = notationData == null ? void 0 : notationData.data.market.name) != null ? _m2 : null
      }
    };
  }
}

export { AlertTriggersListStoreModuleFactory };
